import { createContext } from "react";

export const SherpaContext = createContext('');
